import fillProductKey from './middlewares/fillProductKey'
import populate from './middlewares/populate'
import productsE from './ui/productsE'

module.exports = {
  model: 'products',
  name: 'E-其他資料',
  ui: productsE,
  middlewares: [populate, fillProductKey],
}



// WEBPACK FOOTER //
// ./src/views/productsE.js